/* eslint-disable import/prefer-default-export */
export function normalizeString(content: string): string {
    return content.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function stringToLCAlphaNum(str: string): string {
    return normalizeString(str)
        .toLowerCase()
        .replace(/[^\w\d]/g, '');
}
